export default __webpack_public_path__ + "static/media/terms-background.c76c51b8.jpg";